import React from 'react';
import { number, string, array } from 'prop-types';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import useStyles from 'hooks/useStyles';
import Star from 'components/Star';
import styles from './CommentBlock.scss';

dayjs.extend(customParseFormat);

const LEGAL_DAYJS_FORMAT = 'YYYY-MM-DDTHH:mm:ss.000ZZ';
const DATE_FORMAT = 'YYYY/MM/DD';

const CommentBlock = ({
  stars,
  ratingDate,
  comment,
  tags,
  username,
  avatar,
  className,
}) => {
  useStyles(styles);

  return (
    <div className={className}>
      <div className={styles.info}>
        <img className={styles.avatar} src={avatar} alt={username} />
        <div className={styles.user}>
          <div className={styles.username}>{username}</div>
          <div className={styles.rating}>
            {[1, 2, 3, 4, 5].map(value => (
              <Star
                key={value}
                svgSize={16}
                type={value <= stars ? 'FILLED' : 'BRIGHT_HOLLOW'}
                className={styles.star}
              />
            ))}
            <div className={styles.date}>
              {dayjs(ratingDate, LEGAL_DAYJS_FORMAT).format(DATE_FORMAT)}
            </div>
          </div>
        </div>
      </div>
      <div className={styles.comment}>{comment}</div>
      <div className={styles.tags}>
        {tags.map(tag => (
          <div key={tag} className={styles.tag}>
            {tag}
          </div>
        ))}
      </div>
    </div>
  );
};

CommentBlock.propTypes = {
  stars: number.isRequired,
  ratingDate: string.isRequired,
  comment: string.isRequired,
  tags: array.isRequired,
  username: string.isRequired,
  avatar: string.isRequired,
  className: string,
};

CommentBlock.defaultProps = {
  className: '',
};

export default CommentBlock;
